import { validarCNPJ } from './validarCnpj';

/**
 * Função para fazer parsing flexível de datas
 * Suporta formatos: DD/MM/YYYY, YYYY-MM-DD, timestamps ISO
 * @param dateValue - Valor da data em string ou Date
 * @returns Date object ou null se inválida
 */
export const parseFlexibleDate = (dateValue: string | Date | null | undefined): Date | null => {
  if (!dateValue) return null;
  
  if (dateValue instanceof Date) {
    return isNaN(dateValue.getTime()) ? null : dateValue;
  }
  
  const dateStr = dateValue.toString().trim();
  if (!dateStr) return null;
  
  // Formato brasileiro DD/MM/YYYY
  const brDateMatch = dateStr.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (brDateMatch) {
    const [, day, month, year] = brDateMatch;
    const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    return isNaN(date.getTime()) ? null : date;
  }
  
  // Formato ISO ou outros formatos suportados pelo Date constructor
  const date = new Date(dateStr);
  return isNaN(date.getTime()) ? null : date;
};

/**
 * Formata uma data para o formato brasileiro (DD/MM/YYYY)
 * @param date - Date object ou string
 * @returns String formatada ou string vazia se inválida
 */
export const formatDateToBR = (date: string | Date | null | undefined): string => {
  const parsedDate = parseFlexibleDate(date);
  return parsedDate ? parsedDate.toLocaleDateString('pt-BR') : '';
};

// eslint-disable-next-line import/no-anonymous-default-export
export default { validarCNPJ, parseFlexibleDate, formatDateToBR };
